<template>
  <div class="tool-bar-content">
    <a-space size="large">
      <div class="tool-bar-content-item">
      <UserToolBar></UserToolBar>
      </div>
      <div class="tool-bar-content-item">
      <SettingToolBar></SettingToolBar>
      </div>
    </a-space>
  </div>
</template>
<script>

import UserToolBar from "./user/UserToolBar.vue";
import SettingToolBar from './SettingToolBar.vue';
import MsgToolBar from './message/MsgToolBar';

export default {
    data(){
        return{
          
        }
    },
    methods:{
        update:function(){
           
        }
    },
  
    components:{
      UserToolBar,
      SettingToolBar,
      MsgToolBar
    }

};
</script>

<style >
.tool-bar-content {
  text-align: right;
  width: 100%;
  padding-right: 40px;
}

.tool-bar-content-item{
    border-bottom:3px solid rgba(1, 2, 2, 0);
}

.tool-bar-content-item:hover{
  border-bottom:3px solid rgb(24, 144, 255);
}
</style>